import { getQueryMigrateOnSaveParams } from "containers/Resources/screens/ResourcesSingle/utils";
import { useWorkspaceConfigValue } from "containers/WorkspaceConfig/useWorkspaceConfigValue";

export const useCanCommitOnSave = (isGitEnabled) => {
    const gitAutocommitEnabled = useWorkspaceConfigValue("GIT_AUTOCOMMIT_ENABLED") === true;
    const canCommitOnSaveDefaultValue = isGitEnabled ? gitAutocommitEnabled : false;
    return {
        canCommitOnSaveDefaultValue,
    };
};

export const ON_SAVE_MIGRATE_DEPRECATIONS_ENABLED = "ON_SAVE_MIGRATE_DEPRECATIONS_ENABLED";

export const useMigrateOnSaveParams = () => {
    const isMigrateDeprecationsOnSaveEnabled =
        useWorkspaceConfigValue(ON_SAVE_MIGRATE_DEPRECATIONS_ENABLED) === true;
    const migrateOnSaveParams = getQueryMigrateOnSaveParams(isMigrateDeprecationsOnSaveEnabled);

    return migrateOnSaveParams;
};
